import classNames from 'classnames'

export function generateClassNameForCell(
  status: { id: number; name: string },
  type = 'content'
): string {
  if (status.id === 3) {
    return classNames(`table-columns__${type}`, 'table-cell-green-light')
  }
  return classNames(`table-columns__${type}`, 'table-cell-red-light')
}
